/* Controller */

(function() {
  'use strict';

  /**
   * @author Dahang Xu
   * @description Controller of Semafone CreditCard
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui').controller('uteSemafoneCreditCardCtrl', _controller);

  _controller.$inject = [
    '$scope',
    '$rootScope',
    '$sce',
    '$filter',
    'notifier',
    'uteSemafonePaymentService',
    'uteSemafoneCreditCardService',
    'uteSemafoneService',
    'uteSemafonePCIService',
    'uteSemafonePCITokeniseService'
  ];

  /* @ngInject */
  function _controller(
    $scope,
    $rootScope,
    $sce,
    $filter,
    notifier,
    uteSemafonePaymentService,
    uteSemafoneCreditCardService,
    uteSemafoneService,
    uteSemafonePCIService,
    uteSemafonePCITokeniseService
  ) {
    var vm = this; // jshint ignore:line

    vm.pciEnabled = false;
    if ($rootScope.ruiMethods.user.is.agent()) {
      if ($rootScope.ruiMethods.agent.creditCardSwipeEnabled() === 'true') {
        vm.pciEnabled = true;
      }
    }

    vm.isNotValidCard = false;
    vm.firedOnce;
    vm.isCybersourceError = false;
    vm.months, vm.years;
    vm.cards = {};
    vm.creditPaymentObj = {};
    vm.validateSecurityCode = validateSecurityCode;
    vm.validateExpireDate = validateExpireDate;
    vm.callDigest = callDigest;

    vm.semafoneIframeUrl;
    vm.payNowRule = {};
    vm.decodeSpaces = decodeSpaces;

    vm.loadSemafoneCapturePageIframe = loadSemafoneCapturePageIframe;
    vm.semafoneCapturePageEventHandlers = semafoneCapturePageEventHandlers;
    vm.listenSemafoneCaptureIframeEvents = listenSemafoneCaptureIframeEvents;

    vm.token = '';
    vm.cardScheme = '';
    vm.maskedCardNumber = '';
    vm.semafoneTokeniseErrorCode = '';
    vm.semafoneTokeniseReasonCode = '';
    vm.isPanResetOnInitialFocus = true;
    vm.isPanFocusedOnInitialise = false;
    vm.semafoneTokeniseResponseCode = '';
    vm.semafoneTokeniseErrorDesc = '';
    vm.semafoneValidationState = '';
    vm.semafoneState = '';
    vm.cybersourceTokeniseResponseCode = '';
    vm.cybersourceTokeniseReasonCode = '';
    vm.cybersourceTokeniseMessage = '';
    vm.cybersourceTokeniseErrorCause = '';

    vm.months = uteSemafonePaymentService.months;
    vm.years = uteSemafonePaymentService.expireYears();
    vm.cards = {
      visa: {
        id: 0,
        name: 'VISA',
        image: '/html-fido/cms/ute/fido/images/visa-icon-1217.png'
      },
      mc: {
        id: 1,
        name: 'MASTER',
        image: '/html-fido/cms/ute/fido/images/mc.png'
      },
      amex: {
        id: 2,
        name: 'AMEX',
        image: '/html-fido/cms/ute/fido/images/am.png'
      }
    };

    vm.creditPaymentObj = {
      creditCardType: null,
      creditCardNo: null,
      expireDate: {
        month: null,
        year: null
      },
      securityCode: null
    };

    vm.payNowRule = {
      amount: {
        type: 'number',
        min: 0.01
      },
      ccNumber: {
        pattern: '([0-9]{4}[ -]?){4}'
      },
      expMonth: {
        type: 'number',
        min: 1,
        max: 12
      },
      expYear: {
        type: 'number',
        min: 2015,
        max: 2025
      },
      securityCode: {
        type: 'number',
        minlength: 3,
        maxlength: 4
      },
      ccName: {
        pattern: 'VISA|MASTER|AMEX'
      }
    };

    if (vm.pciEnabled) {
      pciPayment();
    } else {
      activate();
    }

    if (!String.prototype.endsWith) {
      String.prototype.endsWith = function(searchString, position) {
        var subjectString = this.toString();
        if (
          typeof position !== 'number' ||
          !isFinite(position) ||
          Math.floor(position) !== position ||
          position > subjectString.length
        ) {
          position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
      };
    }

    function activate() {
      vm.semafoneIframeUrl = getSemafoneIframeUrl();
      vm.listenSemafoneCaptureIframeEvents();
    }

    /**
     * Since PCI MagStripe Reader us usb Keyboard mode. add some trick JQuery functions for handle Swipe Card and Full track Encrypt Data properly
     */

    /**
     * * PCI 715 MagStripe Swipe credit card Implementation
     */

    function pciPayment() {
      var debouncedOnPCIKeyUp = _.debounce(onPCIKeyUp, 1500);
      vm.onPCIClick = onPCIClick;
      vm.onCardSwiped = debouncedOnPCIKeyUp;
      vm.onCardTextclick = onCardTextclick;
      vm.showCarText = false;
      vm.showProcessingText = false;
      onSwipeOutSide();
    }

    var swipeData = '';

    function onSwipeOutSide() {
      $scope.$on('$destroy', function() {
        document.removeEventListener('keyup', onSwipedData);
      });
      document.addEventListener('keyup', onSwipedData);
    }

    function onSwipedData(event) {
      if (event.target.id === 'pciCC' || event.target.id === 'cvv') {
        return;
      }
      var keyCode = event.which || event.keyCode;

      if (48 === keyCode || 50 === keyCode) {
        swipeData += String.fromCharCode(keyCode);
      } else {
        swipeData = '';
      }

      if (swipeData.charAt(0) === '0' && (swipeData.length >= 2 && swipeData.charAt(1) === '2')) {
        swipeData = '';
        notifier.notify.error({
          errorCode: 'smpciinvalid'
        });
        angular.element('#pciCC').focus();
      }
    }

    function onPCIClick() {
      emptyDivContent();
      showProcessingSymbol('stop');

      angular.element('#cardText').show();
      vm.showCarText = true;

      resetCreditCardFields();
      vm.encrypteData = '';
    }

    function onCardTextclick() {
      angular.element('#pciCC').focus();
    }

    function onPCIKeyUp() {
      var textVal = angular.element('#pciCC').val();

      angular.element('#pciCC').val('');

      vm.encrypteData = textVal;

      if (vm.encrypteData.charAt(0) === '0' && vm.encrypteData.charAt(1) === '2') {
        angular.element('#cardText').hide();
        vm.showCarText = false;
        showProcessingSymbol('start');
        setTimeout(isNotaSwipe, 120000); //in case of user input 0 and 2 manually should reset after 30s
      } else {
        if (vm.encrypteData.charAt(0) !== '0' || (vm.encrypteData.length >= 2 && vm.encrypteData.charAt(1) !== '2')) {
          vm.encrypteData = '';
        }
        onSwipeCardError();
      }

      validateToken(vm.encrypteData);
    }

    function validateToken(textVal) {
      var hexString = textVal.substring(4, 6) + textVal.substring(2, 4);
      var decVal = parseInt(hexString, 16) + 12;
      // if (textVal.substr(textVal.length - 2) === '03' && textVal.length >= decVal) {
      pciDeviceEventHandler(textVal);
      vm.encrypteData = '';
      // event.preventDefault();
      return false;
      // }
    }

    var interval;
    var i;
    var text;
    var started = false;

    function showProcessingSymbol(check) {
      angular.element('#processingText').show();
      vm.showProcessingText = true;
      if (check === 'start' && started !== true) {
        started = true;

        showProcessingSymbolDot('start');
      } else if (check === 'stop') {
        clearInterval(interval);
        i = 0;
        angular.element('#processingText').hide();
        vm.showProcessingText = false;
        started = false;
      }
    }

    function showProcessingSymbolDot(check) {
      angular.element('#processingText').show();
      vm.showProcessingText = true;
      if (check == 'start') {
        clearInterval(interval);
        i = 0;
        text = angular.element('#processingText').text();
        interval = setInterval(updateDiv, 40);
      } else if (check == 'stop') {
        angular.element('#processingText').hide();
        vm.showProcessingText = false;
        clearInterval(interval);
      }
    }

    function updateDiv() {
      angular.element('#processingText').html(text + new Array((++i % 7) + 1).join('. '));
    }

    function emptyDivContent() {
      angular.element('#processingText').empty();
      angular.element('#processingText').text($filter('translate')('global.label.pciProcessText'));
    }

    function pciDeviceEventHandler(textVal) {
      var temp = uteSemafonePCIService.getEncryptedCardNumber(textVal);
      if (temp !== '') {
        uteSemafonePCITokeniseService.getMaskCardNumber(temp, function(_data) {
          var xmlData = _data.data;
          var errorCode, responseMsg;
          if (_data.result === 'success') {
            responseMsg = finTagValueByEndsWith(xmlData, 'result');
            if (responseMsg.toUpperCase() === 'SUCCESS') {
              var CardNumber = finTagValueByEndsWith(xmlData, 'token');
              var CardType = finTagValueByEndsWith(xmlData, 'cardtype');
              if (
                CardNumber !== null &&
                CardNumber !== undefined &&
                CardNumber.length > 0 &&
                (CardType !== null && CardType !== undefined && CardType.length > 0)
              ) {
                if (
                  CardType.toLowerCase() === 'v' ||
                  CardType.toLowerCase() === 'm' ||
                  CardType.toLowerCase() === 'a'
                ) {
                  setPCICCInfo({
                    cardNum: CardNumber,
                    cardType: CardType
                  });
                } else if (CardType !== null && CardType !== undefined && CardType.toLowerCase() === 'd') {
                  errorCode = '100893';
                  vm.isNotValidCard = true;
                  vm.isCybersourceError = false;
                  notifier.notify.error({
                    errorCode: errorCode
                  });

                  onSwipeCardError();
                  showProcessingSymbol('stop');
                }
              }
            } else if (responseMsg.toUpperCase() === 'FAIL') {
              var errorInfo = findErrorTags(xmlData);
              vm.isCybersourceError = false;
              vm.isNotValidCard = true;

              notifier.notify.error({
                errorCode: errorInfo.errorCode
              });

              onSwipeCardError();
              showProcessingSymbol('stop');
            }
          } else if (_data.result === 'error') {
            responseMsg = _data.data;
            vm.isCybersourceError = true;
            vm.isNotValidCard = false;
            onSwipeCardError();
            showProcessingSymbol('stop');
          }
        });
      } else {
        showProcessingSymbol('stop');
      }
    }

    function finTagValueByEndsWith(xml, tagName) {
      var returnValue = '';
      $.each($(xml), function(i, e) {
        if (e.nodeName.endsWith('RETAILTOKENISATIONRESPONSE')) {
          $.each($(e).children(), function(i, elm) {
            if (elm.tagName.toLowerCase().endsWith(tagName)) {
              returnValue = elm.textContent;
            }
          });
        }
      });
      return returnValue;
    }

    function findErrorTags(xml) {
      var errorMessage = '';
      var errorCode = '';
      $.each($(xml), function(i, e) {
        if (e.nodeName.endsWith('RETAILTOKENISATIONRESPONSE')) {
          $.each($(e).children(), function(i, elm) {
            if (elm.tagName.toLowerCase().endsWith('error')) {
              $.each($(elm).children(), function(i, elem) {
                if (elem.tagName.toLowerCase().endsWith('code')) {
                  errorCode = elem.textContent;
                } else {
                  errorMessage += elem.textContent;
                }
              });
            }
          });
        }
      });

      var errorInfo = {
        errorCode: errorCode,
        errorMessage: errorMessage
      };
      return errorInfo;
    }

    function setPCICCInfo(ccInfo) {
      vm.token = ccInfo.cardNum;
      vm.cardScheme = ccInfo.cardType;

      uteSemafoneService.setSemafoneValidationState('SUCCESS');

      uteSemafoneService.setToken(vm.token);

      vm.maskedCardNumber = createMaskedPan(ccInfo.cardNum);

      uteSemafoneService.setMaskedCardNumber(vm.maskedCardNumber);

      vm.isNotValidCard = false;
      vm.isCybersourceError = false;

      setCardScheme(ccInfo.cardType);

      $scope.$emit('Event:SFEvents:Tokenized');

      angular.element('#cardText').hide();
      angular.element('#processingText').hide();

      vm.showCarText = false;
      vm.showProcessingText = false;
      vm.showLoading = false;
      showProcessingSymbol('stop');
    }

    function setCardScheme(type) {
      var cardType = {
        V: function() {
          vm.creditPaymentObj.creditCardType = 'VISA';
          uteSemafoneService.setCardScheme('VISA');
          uteSemafoneService.setExpectedSecurityCodeLength(3);
        },
        M: function() {
          vm.creditPaymentObj.creditCardType = 'MASTER';
          uteSemafoneService.setCardScheme('MASTERCARD');
          uteSemafoneService.setExpectedSecurityCodeLength(3);
        },
        A: function() {
          vm.creditPaymentObj.creditCardType = 'AMEX';
          uteSemafoneService.setCardScheme('AMEX');
          uteSemafoneService.setExpectedSecurityCodeLength(4);
        },
        default: function() {
          vm.creditPaymentObj.creditCardType = '';
          uteSemafoneService.setCardScheme('');
          uteSemafoneService.setExpectedSecurityCodeLength(0);
        }
      };

      return (cardType[type] || cardType['default'])();
    }

    //PCI-DSS mask last 4 digts mask PAN
    function createMaskedPan(cardToken) {
      return cardToken
        .replace(/\d(?=\d{4})/g, '*')
        .replace(/(.{4})/g, '$1 ')
        .trim();
    }

    function isNotaSwipe() {
      if (vm.showProcessingText) {
        showProcessingSymbol('stop');
        angular.element('#pciCC').focus();
      }
    }

    function onSwipeCardError() {
      angular.element('#cardText').show();
      vm.showCarText = true;

      vm.token = '';
      vm.cardScheme = '';
      vm.maskedCardNumber = '';

      uteSemafoneService.setToken('');
      uteSemafoneService.setCardScheme('');
      uteSemafoneService.setMaskedCardNumber('');
      uteSemafoneService.setSemafoneValidationState('Unknown');
      uteSemafoneService.setExpectedSecurityCodeLength(0);
    }

    function resetCreditCardFields() {
      vm.token = '';
      vm.cardScheme = '';
      vm.maskedCardNumber = '';

      vm.semafoneTokeniseReasonCode = '';
      vm.semafoneTokeniseResponseCode = '';
      vm.semafoneTokeniseErrorCode = '';
      vm.semafoneTokeniseErrorDesc = '';
      vm.cybersourceTokeniseResponseCode = '';
      vm.cybersourceTokeniseReasonCode = '';
      vm.cybersourceTokeniseMessage = '';
      vm.cybersourceTokeniseErrorCause = '';

      uteSemafoneService.setToken('');
      uteSemafoneService.setCardScheme('');
      uteSemafoneService.setMaskedCardNumber('');
      uteSemafoneService.setSemafoneValidationState('Unknown');
      uteSemafoneService.setExpectedSecurityCodeLength(0);
      vm.isNotValidCard = false;
      vm.isCybersourceError = false;
      vm.creditPaymentObj.creditCardType = null;
    }

    function validateSecurityCode() {}

    function validateExpireDate() {}

    function callDigest() {
      if (!$scope.$$phase) {
        //$digest or $apply to make sure that the view is getting updated when scope changes
        $scope.$digest();
      }
    }

    function getSemafoneIframeUrl() {
      var _semafoneIframeUrl = $sce.trustAsHtml(
        '<iframe src="' +
          $sce.trustAsResourceUrl(
            uteSemafoneCreditCardService.loadSemafoneCapturePageUrl(
              vm.maskedCardNumber,
              vm.isPanFocusedOnInitialise,
              vm.isPanResetOnInitialFocus
            ) +
              '#' +
              encodeURIComponent(document.location.href)
          ) +
          '" class="ute-input-text", scrolling="no" transparency="true" offset="0" border="0" outline="0" frameBorder="0" frameborder="0" marginwidth="0" marginheight="0"></iframe>'
      );
      return _semafoneIframeUrl;
    }

    function decodeSpaces(s) {
      s = s.replace(/\+/g, ' ');
      return s;
    }

    function loadSemafoneCapturePageIframe() {
      //alert("loadSemafoneCapturePageIframe");
      vm.semafoneIframeUrl = '';
      vm.callDigest();
      vm.semafoneIframeUrl = $sce.trustAsHtml(
        '<iframe src="' +
          $sce.trustAsResourceUrl(
            uteSemafoneCreditCardService.loadSemafoneCapturePageUrl(
              vm.maskedCardNumber,
              vm.isPanFocusedOnInitialise,
              vm.isPanResetOnInitialFocus
            ) +
              '#' +
              encodeURIComponent(document.location.href)
          ) +
          '" class="ute-input-text", scrolling="no" transparency="true" offset="0" border="0" outline="0" frameBorder="0" frameborder="0" marginwidth="0" marginheight="0"></iframe>'
      );
      vm.callDigest();
      //console.log('$scope.semafoneIframeUrl :: ' + vm.semafoneIframeUrl);
      vm.listenSemafoneCaptureIframeEvents();
    }

    function semafoneCapturePageEventHandlers(semafoneEvents) {
      angular
        .element('#semafone-iframe')
        .contents()
        .find('#pan')
        .css({
          border: 0,
          height: 35 + 'px',
          outline: 0
        });

      if (semafoneEvents.semafoneState && semafoneEvents.semafoneState.length > 0) {
        //angular.element('#semafoneState').val(semafoneEvents.semafoneState);
        vm.semafoneState = semafoneEvents.semafoneState;
      }
      if (semafoneEvents.semafoneValidationState && semafoneEvents.semafoneValidationState.length > 0) {
        //angular.element('#semafoneValidationState').val(semafoneEvents.semafoneValidationState);
        vm.semafoneValidationState = semafoneEvents.semafoneValidationState;
      }
      if (semafoneEvents.semafoneValidationErrorCode && semafoneEvents.semafoneValidationErrorCode.length > 0) {
        //angular.element('#semafoneValidationErrorCode').val(semafoneEvents.semafoneValidationErrorCode);
        if (semafoneEvents.semafoneValidationErrorCode === '100799' && semafoneEvents.semafoneState === 'ACTIVE') {
          vm.isNotValidCard = false;
          vm.isCybersourceError = true;
        }
        vm.semafoneValidationErrorCode = semafoneEvents.semafoneValidationErrorCode;
      } else {
        //angular.element('#semafoneValidationErrorCode').val('');
        vm.semafoneValidationErrorCode = '';
      }

      if (semafoneEvents.semafoneValidationErrorDesc && semafoneEvents.semafoneValidationErrorDesc.length > 0) {
        //angular.element('#semafoneValidationErrorDesc').val(semafoneEvents.semafoneValidationErrorDesc);
        vm.semafoneValidationErrorDesc = semafoneEvents.semafoneValidationErrorDesc;
      } else {
        //angular.element('#semafoneValidationErrorDesc').val('');
        vm.semafoneTokeniseErrorDesc = '';
      }

      if (
        semafoneEvents.semafoneState &&
        semafoneEvents.semafoneState.length > 0 &&
        semafoneEvents.semafoneState === 'ACTIVE'
      ) {
        //angular.element('#token').val('');
        //angular.element('#cardScheme').val('');
        //angular.element('#maskedCardNumber').val('');
        vm.token = '';
        vm.cardScheme = '';
        vm.maskedCardNumber = '';
        //angular.element('#semafoneTokeniseReasonCode').val('');
        //angular.element('#semafoneTokeniseResponseCode').val('');
        //angular.element('#semafoneTokeniseErrorCode').val('');
        //angular.element('#semafoneTokeniseErrorDesc').val('');
        //angular.element('#cybersourceTokeniseResponseCode').val('');
        //angular.element('#cybersourceTokeniseReasonCode').val('');
        //angular.element('#cybersourceTokeniseMessage').val('');
        //angular.element('#cybersourceTokeniseErrorCause').val('');

        vm.semafoneTokeniseReasonCode = '';
        vm.semafoneTokeniseResponseCode = '';
        vm.semafoneTokeniseErrorCode = '';
        vm.semafoneTokeniseErrorDesc = '';
        vm.cybersourceTokeniseResponseCode = '';
        vm.cybersourceTokeniseReasonCode = '';
        vm.cybersourceTokeniseMessage = '';
        vm.cybersourceTokeniseErrorCause = '';

        uteSemafoneService.setToken('');
        uteSemafoneService.setCardScheme('');
        uteSemafoneService.setMaskedCardNumber('');
        uteSemafoneService.setSemafoneValidationState('Unknown');
        uteSemafoneService.setExpectedSecurityCodeLength('');
        vm.isNotValidCard = vm.firedOnce;
        vm.isCybersourceError = false;
        vm.creditPaymentObj.creditCardType = null;
        $scope.$emit('Event:SFEvents:Tokenized');
        vm.callDigest();
      }
      if (
        semafoneEvents.semafoneState &&
        semafoneEvents.semafoneState.length > 0 &&
        semafoneEvents.semafoneState !== 'COMPLETE'
      ) {
        //angular.element('#semafoneState').val(semafoneEvents.semafoneState);
        vm.semafoneState = semafoneEvents.semafoneState;
      }
      if (
        semafoneEvents.semafoneValidationState &&
        semafoneEvents.semafoneValidationState.length > 0 &&
        semafoneEvents.semafoneValidationState !== 'SUCCESS'
      ) {
        //angular.element('#semafoneValidationState').val(semafoneEvents.semafoneValidationState);
        vm.semafoneValidationState = semafoneEvents.semafoneValidationState;
      }
      if (
        semafoneEvents.semafoneValidationState &&
        semafoneEvents.semafoneValidationState.length > 0 &&
        semafoneEvents.semafoneValidationState === 'FAIL'
      ) {
        uteSemafoneService.setToken('');
        uteSemafoneService.setMaskedCardNumber('');
        uteSemafoneService.setCardScheme('');
        uteSemafoneService.setSemafoneValidationState('FAIL');
        uteSemafoneService.setExpectedSecurityCodeLength('');
        if (typeof vm.firedOnce === 'undefined' && semafoneEvents.semafoneValidationErrorCode === '100898') {
          vm.firedOnce = true;
        }
        vm.isNotValidCard = true;
        vm.isCybersourceError = false;
        vm.creditPaymentObj.creditCardType = null;
        vm.callDigest();
      }

      if (semafoneEvents.semafoneResponseCode && semafoneEvents.semafoneResponseCode.length > 0) {
        //angular.element('#semafoneTokeniseResponseCode').val(semafoneEvents.semafoneResponseCode);
        vm.semafoneTokeniseResponseCode = semafoneEvents.semafoneResponseCode;
        if (
          semafoneEvents.semafoneResponseCode !== 'SUCCESS' &&
          (!semafoneEvents.serviceResponseCode || semafoneEvents.serviceResponseCode.length < 1)
        ) {
          //angular.element('#isPanResetOnInitialFocus').val(true);
          vm.isPanResetOnInitialFocus = true;
          vm.loadSemafoneCapturePageIframe();
          //launchSemafoneCapturePage('semafoneCapturePage');
        }
      }
      if (semafoneEvents.semafoneErrorCode && semafoneEvents.semafoneErrorCode.length > 0) {
        angular.element('#semafoneTokeniseErrorCode').val(semafoneEvents.semafoneErrorCode);
        if (semafoneEvents.semafoneErrorCode == 200101 || semafoneEvents.semafoneErrorCode == 201999) {
          //$('#error404').css('display','block');
          vm.isNotValidCard = false;
          vm.isCybersourceError = true;
          vm.callDigest();
        }
      }
      if (semafoneEvents.semafoneErrorCause && semafoneEvents.semafoneErrorCause.length > 0) {
        //angular.element('#semafoneTokeniseErrorDesc').val(semafoneEvents.semafoneErrorCause);
        vm.semafoneTokeniseErrorDesc = semafoneEvents.semafoneErrorCause;
      }
      if (semafoneEvents.serviceResponseCode && semafoneEvents.serviceResponseCode.length > 0) {
        //angular.element('#cybersourceTokeniseResponseCode').val(semafoneEvents.serviceResponseCode);
        vm.cybersourceTokeniseResponseCode = semafoneEvents.serviceResponseCode;
        if (semafoneEvents.serviceResponseCode != 100) {
          //angular.element('#isPanResetOnInitialFocus').val(true);
          vm.isPanResetOnInitialFocus = true;
          vm.loadSemafoneCapturePageIframe();
          //launchSemafoneCapturePage('semafoneCapturePage');
        }
      }
      if (semafoneEvents.serviceErrorCause && semafoneEvents.serviceErrorCause.length > 0) {
        //angular.element('#cybersourceTokeniseErrorCause').val(semafoneEvents.serviceErrorCause);
        vm.cybersourceTokeniseErrorCause = semafoneEvents.serviceErrorCause;
      }
      if (semafoneEvents.serviceReasonCode && semafoneEvents.serviceReasonCode.length > 0) {
        //angular.element('#cybersourceTokeniseReasonCode').val(semafoneEvents.serviceReasonCode);
        vm.cybersourceTokeniseReasonCode = semafoneEvents.serviceReasonCode;
      }
      if (semafoneEvents.serviceMessage && semafoneEvents.serviceMessage.length > 0) {
        //angular.element('#cybersourceTokeniseMessage').val(semafoneEvents.serviceMessage);
        vm.cybersourceTokeniseMessage = semafoneEvents.serviceMessage;
      }

      if (semafoneEvents.processResultState === 'SUCCESS') {
        vm.isNotValidCard = false;
        vm.isCybersourceError = false;

        uteSemafoneService.setSemafoneValidationState('SUCCESS');

        if (semafoneEvents.cardScheme && semafoneEvents.cardScheme.length > 0) {
          //angular.element('#cardScheme').val(semafoneEvents.cardScheme);
          vm.cardScheme = semafoneEvents.cardScheme;
          if (semafoneEvents.token && semafoneEvents.token.length > 0) {
            uteSemafoneService.setCardScheme(semafoneEvents.cardScheme);
          }
        }

        if (semafoneEvents.expectedSecurityCodeLength && semafoneEvents.expectedSecurityCodeLength.length > 0) {
          uteSemafoneService.setExpectedSecurityCodeLength(semafoneEvents.expectedSecurityCodeLength);
        }

        if (semafoneEvents.token && semafoneEvents.token.length > 0) {
          //angular.element('#token').val(semafoneEvents.token);
          vm.token = semafoneEvents.token;
          uteSemafoneService.setToken(semafoneEvents.token);
          $scope.$emit('Event:SFEvents:Tokenized');
          vm.firedOnce = false;
        }

        if (semafoneEvents.maskedPan && semafoneEvents.maskedPan.length > 0) {
          //angular.element('#maskedCardNumber').val(semafoneEvents.maskedPan);
          vm.maskedCardNumber = semafoneEvents.maskedPan;
          uteSemafoneService.setMaskedCardNumber(semafoneEvents.maskedPan);
          //angular.element('#isPanResetOnInitialFocus').val(true);
          vm.isPanResetOnInitialFocus = true;
          if (uteSemafoneService.getCardScheme() === 'VISA') {
            vm.creditPaymentObj.creditCardType = 'VISA';
          } else if (uteSemafoneService.getCardScheme() === 'MASTERCARD') {
            vm.creditPaymentObj.creditCardType = 'MASTER';
          } else if (uteSemafoneService.getCardScheme() === 'AMEX') {
            vm.creditPaymentObj.creditCardType = 'AMEX';
          } else {
            vm.creditPaymentObj.creditCardType = null;
            vm.isNotValidCard = true;
          }
          vm.callDigest();
          vm.loadSemafoneCapturePageIframe();
        }
      } else if (semafoneEvents.processResultState === 'FAIL') {
        uteSemafoneService.setToken('');
        uteSemafoneService.setMaskedCardNumber('');
        uteSemafoneService.setCardScheme('');
        uteSemafoneService.setSemafoneValidationState('FAIL');
        uteSemafoneService.setExpectedSecurityCodeLength('');
        vm.isNotValidCard = false;
        vm.isCybersourceError = true;
        vm.creditPaymentObj.creditCardType = null;
        vm.callDigest();
      }
    }

    function listenSemafoneCaptureIframeEvents() {
      vm.semafoneEvents = {
        semafoneState: '',
        semafoneValidationState: '',
        semafoneValidationErrorCode: '',
        semafoneValidationErrorDesc: '',
        cardScheme: '',
        currentCardNumberLength: '',
        expectedCardNumberLength: '',
        expectedSecurityCodeLength: '',
        token: '',
        maskedPan: '',
        processResultState: '',
        semafoneResponseCode: '',
        semafoneReasonCode: '',
        semafoneErrorCode: '',
        semafoneErrorName: '',
        semafoneErrorCause: '',
        semafoneErrorRemedy: '',
        semafoneWarningCode: '',
        semafoneWarningName: '',
        semafoneWarningCause: '',
        semafoneWarningRemedy: '',
        serviceReasonCode: '',
        serviceResponseCode: '',
        serviceMessage: '',
        serviceErrorCode: '',
        serviceErrorName: '',
        serviceErrorCause: '',
        serviceErrorRemedy: ''
      };

      $.receiveMessage(function(event) {
        var bar = event.data.split('&');
        for (var i = 0; i < bar.length; i++) {
          var pair = bar[i].split('=');
          var key = pair[0];
          var value = pair[1];
          if (key === 'semafoneState') {
            vm.semafoneEvents.semafoneState = value;
          } else if (key === 'semafoneValidationState') {
            vm.semafoneEvents.semafoneValidationState = value;
          } else if (key === 'semafoneValidationErrorCode') {
            vm.semafoneEvents.semafoneValidationErrorCode = value;
          } else if (key === 'semafoneValidationErrorDesc') {
            vm.semafoneEvents.semafoneValidationErrorDesc = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'cardScheme') {
            vm.semafoneEvents.cardScheme = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'currentCardNumberLength') {
            vm.semafoneEvents.currentCardNumberLength = value;
          } else if (key === 'expectedCardNumberLength') {
            vm.semafoneEvents.expectedCardNumberLength = value;
          } else if (key === 'expectedSecurityCodeLength') {
            vm.semafoneEvents.expectedSecurityCodeLength = value;
          } else if (key === 'token') {
            vm.semafoneEvents.token = decodeURIComponent(value);
          } else if (key === 'maskedPan') {
            vm.semafoneEvents.maskedPan = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'processResultState') {
            vm.semafoneEvents.processResultState = value;
          } else if (key === 'semafoneResponseCode') {
            vm.semafoneEvents.semafoneResponseCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneReasonCode') {
            vm.semafoneEvents.semafoneReasonCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneErrorCode') {
            vm.semafoneEvents.semafoneErrorCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneErrorName') {
            vm.semafoneEvents.semafoneErrorName = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneErrorCause') {
            vm.semafoneEvents.semafoneErrorCause = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneErrorRemedy') {
            vm.semafoneEvents.semafoneErrorRemedy = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneWarningCode') {
            vm.semafoneEvents.semafoneWarningCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneWarningName') {
            vm.semafoneEvents.semafoneWarningName = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneWarningCause') {
            vm.semafoneEvents.semafoneWarningCause = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'semafoneWarningRemedy') {
            vm.semafoneEvents.semafoneWarningRemedy = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceReasonCode') {
            vm.semafoneEvents.serviceReasonCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceResponseCode') {
            vm.semafoneEvents.serviceResponseCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceMessage') {
            vm.semafoneEvents.serviceMessage = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceErrorCode') {
            vm.semafoneEvents.serviceErrorCode = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceErrorName') {
            vm.semafoneEvents.serviceErrorName = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceErrorCause') {
            vm.semafoneEvents.serviceErrorCause = decodeURIComponent(vm.decodeSpaces(value));
          } else if (key === 'serviceErrorRemedy') {
            vm.semafoneEvents.serviceErrorRemedy = decodeURIComponent(vm.decodeSpaces(value));
          }
        }
        vm.semafoneCapturePageEventHandlers(vm.semafoneEvents);
      });
    }
  }
})();
